/*
 * @Descripttion:
 * @Author: zhaozheng
 * @Version: 0.0.1
 * @Date: 2025-11-13 14:53:47
 * @LastEditors: zhaozheng
 * @LastEditTime: 2025-11-21 17:20:30
 */
import React, { VFC } from 'react';
import { css } from '@emotion/css';
import { useBgControl } from '../BgControlContext';

export const P1Home: VFC = () => {
  const bgControl = useBgControl();

  const handleContactClick = () => {
    bgControl?.setModalOpen(true);
  };

  return (
    <section className={styles.wrapper} aria-label="P1 Home">
      <h1 className={styles.title}>AI Agent</h1>
      <p className={styles.subtitle}>
        专注企业级AI智能体定制，为您构建“千企千面”的专属智能体
      </p>
      <div className={styles.ctaWrapper}>
        <button className={styles.ctaBtn} onClick={handleContactClick}>
          联系我们
        </button>
      </div>
    </section>
  );
};

const styles = {
  wrapper: css`
    pointer-events: none;
    position: relative;
    min-height: calc(var(--vh, 1vh) * 100);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 6vh 0;
    color: #fff;
    text-align: center;
    z-index: 100;
    width: min(1400px, 92vw);
  `,
  title: css`
    pointer-events: auto;
    font-size: 52px;
    font-weight: 800;
    margin: 0 0 20px 0;
    letter-spacing: 0.02em;
    opacity: 0;
    transform: translate3d(30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    
    @media (max-width: 768px) {
      font-size: 40px;
    }
  `,
  subtitle: css`
    pointer-events: auto;
    font-size: 20px;
    margin: 0;
    opacity: 0;
    transform: translate3d(-30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 0.9;
      transform: translate3d(0, 0, 0);
    }
  `,
  ctaWrapper: css`
    margin-top: 60px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s;
    pointer-events: auto;
    
    .reveal-visible & {
      opacity: 1;
      transform: translateY(0);
    }
  `,
  ctaBtn: css`
    appearance: none;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 999px;
    color: #fff;
    padding: 12px 48px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    letter-spacing: 1px;
    outline: none;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: #fff;
      transform: translateY(-2px);
    }
    
    &:active {
      transform: translateY(0);
    }
  `,
};
